module.exports = __webpack_public_path__ + "static/media/womancircle.ac94367d.png";